module.exports = __webpack_public_path__ + "assets/img/reserving.23b901e92409e788f9d6860cda275d48.png";